// extracted by mini-css-extract-plugin
export default {"landing-nft":"LandingNftCard_landing-nft__BZG4a","landing-nft__price":"LandingNftCard_landing-nft__price__QE9xw","landing-nft__button":"LandingNftCard_landing-nft__button__R-42Y"};